import { DataBean } from "../DataBean";

export class FreightRate extends DataBean {



    public async deleteFreightRate(idFreightRate: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "void_deleteFreightRate_Number", [idFreightRate]);
    }

    public async getFreightRateCatalog(regexStr: any, page: any, recordsPerPage: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.advantage.shared.Report_getFreightRateCatalog_String_Number_Number", [regexStr, page, recordsPerPage]);
    }

}